<template>
  <Dialog :visible.sync="innerVisible" width="490px" hideTitle>
    <template #title></template>
    <el-row type="flex" justify="space-between" class="tab-wrapper">
      <el-tabs value="1" class="my-tabs">
        <el-tab-pane label="修改账户信息" name="1"></el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row type="flex">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="100px"
        class="form"
      >
        <el-form-item prop="userName" label="用户姓名">
          <el-input v-model="form.userName" placeholder="请输入用户姓名">
          </el-input>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input v-model="form.phone" placeholder="请输入联系电话">
          </el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"> </el-input>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" justify="center">
      <el-button type="primary" @click="handleSubmit" class="btn"
        >确认</el-button
      >
    </el-row>
  </Dialog>
</template>

<script>
import visibleMixin from "@/mixins/visibleMixin";
import { editInfoRules as rules } from "@/utils/validator";
import Dialog from "@/components/Dialog.vue";

export default {
  mixins: [visibleMixin],

  components: {
    Dialog,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        userName: "", // 用户姓名
        phone: "", // 联系电话
        email: "", // 邮箱
      },
      rules,
    };
  },

  watch: {
    innerVisible() {
      this.$refs.form?.resetFields();
    },
  },

  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        let { userName, phone, email } = this.form;
        let { success, msg } = await this.$api.userupdateUser({
          userName,
          telephone: phone,
          email,
        });
        if (success) {
          this.$message.success(msg);
          this.innerVisible = false
          if (this.$store.getters['user/userInfo'].userName !== userName) {
            this.$store.dispatch('user/logout', { diableGetAuth: true })
            setTimeout(() => {
              this.$router.push('/')
            }, 2000)
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$line-height: 25px;

.el-dialog__wrapper {
  &.dialog {
    /deep/ .el-dialog__header {
      .el-dialog__title {
        color: #000;
        font-weight: 600;
      }
      .el-dialog__close {
        font-size: 22px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    /deep/ .el-dialog__body {
      padding: 35px 30px 40px;
      .el-tabs__header {
        margin-bottom: 36px;
        .el-tabs__item {
          margin-bottom: 12px;
          height: auto;
          line-height: $line-height;
          color: #323233;
        }
      }
      .el-form {
        width: 100%;
        .el-form-item {
          position: relative;
          margin-bottom: 49px;
          &:last-child {
            margin-bottom: 65px;
          }
          &::after {
            content: "";
            position: absolute;
            bottom: -24px;
            width: 100%;
            height: 2px;
            background: #ebeef5;
          }
        }
        .el-form-item__label {
          @extend .f18;
          color: #323233;
          line-height: $line-height;
        }
        .el-form-item__content {
          line-height: $line-height;
          .el-select {
            width: 76px;
            color: #000;
          }
          .el-input__inner {
            @extend .f18;
            color: #000;
            border: none;
            height: auto;
            line-height: $line-height;
          }
          .el-input-group__prepend {
            &::after {
              content: "";
              display: inline-block;
              position: relative;
              left: 20px;
              width: 1px;
              height: 27px;
              background: #ebeef5;
              vertical-align: middle;
            }
          }
          .btn-send-code {
            padding: 0;
            width: 90px;
            height: 32px;
            border-radius: 5px;
            color: #409eff;
            border: 1px solid #409eff;
          }
        }
      }
    }
  }
}
.text {
  color: #323233;
  &-register {
    margin: 41px 0 40px;
  }
  &-login {
    margin: 16px 0 40px;
    .btn-register {
      padding: 0;
      @extend .f18;
      line-height: 1;
    }
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: initial;
  }
  .el-radio__label {
    padding-left: 8px;
  }
  &-hyperlink {
    margin-bottom: 40px;
    color: #409eff;
  }
}
.btn {
  width: 100%;
  height: 48px;
  background: #1890ff;
  border-radius: $border-radius;
}
</style>
